{
 "name": "0_apple",
 "bin": "0_apple.bin",
 "nodes": [
  {"name": "", "parent": -1, "t": [0,0,0], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Fbx_Root", "parent": 0, "t": [0,0,0], "q": [-0.7071068,0,0,0.7071068], "s": [0.0254,0.0254,0.0254]},
  {"name": "Producer Perspective", "parent": 0, "t": [0,0.713,2.875], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Top", "parent": 0, "t": [0,40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Bottom", "parent": 0, "t": [0,-40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Front", "parent": 0, "t": [0,0,40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Back", "parent": 0, "t": [0,0,-40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Right", "parent": 0, "t": [40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Left", "parent": 0, "t": [-40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Camera Switcher", "parent": 0, "t": [0,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "0_apple", "parent": 1, "t": [0,0,0], "q": [-0.4985105,0.4791606,0.5227385,0.4986351], "s": [1,1,1]},
  {"name": "Cylinder01", "parent": 10, "t": [-1.113974e-05,-0.8512,22.36108], "q": [0,0,0.9981831,0.06025345], "s": [1,1,1]},
  {"name": "Line01", "parent": 10, "t": [-0.6052399,0.5107474,25.2757], "q": [0.1463962,-0.2501106,-0.1220784,0.949268], "s": [0.8392338,1.368858,1.000146]},
  {"name": "Line02", "parent": 10, "t": [1.907349e-06,14.98451,-11.01712], "q": [-0.5000005,0.4999999,0.5000003,-0.4999993], "s": [1,1,1]}
 ],
 "parts": [
  {"node": 11, "vertexCount": 78, "posOffset": 0, "nrmOffset": 936, "uvOffset": 1872, "material": "0_apple_stil", "color": [0.2824,0.1451,0,1], "texture": "apfel_stil.png"},
  {"node": 12, "vertexCount": 72, "posOffset": 2496, "nrmOffset": 3360, "uvOffset": 4224, "material": "0_Apple_leav", "color": [0.06667,0.2902,0,1], "texture": "apfelblatt.png"},
  {"node": 13, "vertexCount": 1044, "posOffset": 4800, "nrmOffset": 17328, "uvOffset": 29856, "material": "0_apple", "color": [1,0,0,1], "texture": "apple.png"}
 ],
 "anims": [
  {"name": "create", "duration": 0.43333, "fps": 30, "frames": 14, "offset": 38208},
  {"name": "grow", "duration": 0.36667, "fps": 30, "frames": 12, "offset": 46048},
  {"name": "idle", "duration": 0.36667, "fps": 30, "frames": 12, "offset": 52768},
  {"name": "pick", "duration": 0.36667, "fps": 30, "frames": 12, "offset": 59488}
 ]
}
